import React, {FC} from "react";
import BTable2 from "../../../components/b-table2";
import Sponsor from "../sponsor";
import AddressName from "../../common/address-name";
import {Link} from "react-router-dom";
import useCommon from "../../../common/hooks/useCommon";


interface ListingLayoutData {
    title: any,
    subTitle?: any,
    address?: any,
    listingHeader?: any,
    pagination?: any;
    totalRecords?: any;
    onPagination?: any;
    loading?: any,
    list?: any,
    tableHeader?: any,
    tableData?: any,
    header?: any,
    tableClassName?: any,
    statistics?: any,
    sort?: any,
    onSort?: any,
    options?: any;
    extraData?: any;
}

const ListingLayout: FC<ListingLayoutData> = (props) => {
    const {get0x} = useCommon();

    return (
        <React.Fragment>
            <div className="py-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="bs-page-title bs-font ">
                                {!props?.address ? props?.title : null}
                                {props?.subTitle && (
                                    <React.Fragment>
                                        <br/>
                                        <span className="bs-page-title-secondary">{props?.subTitle}</span>
                                    </React.Fragment>
                                )}
                                {props?.address && (
                                    <React.Fragment>
                                        <div className="title-container d-flex flex-column gap-1">
                                            <div className="title">{props?.extraData} Transactions</div>
                                            <div className="date">For
                                                <Link to={`/address/${get0x(props?.address)}`}><AddressName data={props?.address}/>{props?.address}</Link>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                    <Sponsor/>
                    {!!props?.statistics && props?.statistics}
                    <div className="row">
                        <div className="col-lg-12">
                            <BTable2
                                title={props?.listingHeader}
                                className={props?.tableClassName}
                                header={props?.header}
                                list={props?.list}
                                loading={props?.loading}
                                pagination={props?.pagination}
                                totalRecords={props?.totalRecords}
                                onPagination={props?.onPagination}
                                sort={props?.sort}
                                onSort={props?.onSort}
                                options={props?.options}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ListingLayout;
